import { config } from '@/config';

// Signin
export function signin(email, pass) {
  if (config.auth.provider === 'localStorage') {
    return Promise.resolve({ token: 'Local' });
  }
  return fetch(`${config.auth.url}rpc/login`,
    {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json; charset=utf-8',
      }),
      mode: 'cors',
      cache: 'no-cache',
      referrer: 'no-referrer',
      body: JSON.stringify({ 'email': email, 'pass': pass }),
    }
  )
    .then(response => {
      return response.json();
    })
    .then(response => {
      if (response.length === 1) return response[0];
      else return response;
    })
    .catch(err => {
      throw err;
    });
}

// Signout
export function signout() {
  localStorage.removeItem('token');
}

// Get the current authenticated user.
export function getUser() {
  return null;
}
